<ng-container *ngIf=" isLoaded; else spinner">
    <table class="mdl-data-table mdl-js-data-table mdl-data-table--selectable mdl-shadow--2dp monitoring-table">
        <thead>
            <tr>
                <th class="mdl-data-table__cell--non-numeric" style="width: 30%;">Property</th>
                <th class="mdl-data-table__cell--non-numeric" style="width: 40%;">Description</th>
                <th style="width: 10%;">Value</th>
                <th style="width: 10%;">Health</th>
                <th style="width: 10%;">Actions</th>
            </tr>
        </thead>
        <tbody>
            <tr app-instance-monitoring-unsynchronized-cr-group-ids-row
                [instanceMonitoringData]="instanceMonitoringData" (actionPerformed)="fixHappened()">
            </tr>
            <tr app-i-m-last-updated-row [instanceMonitoringData]="instanceMonitoringData"
                (actionPerformed)="fixHappened()" [instance]="instance">
            </tr>
        </tbody>
    </table>
</ng-container>

<ng-template #spinner>
    <app-spinner></app-spinner>
</ng-template>
